const BRAND_GGV = "vax";
const BRAND_GGD = "doc";
const BRAND_GGT = "tested";

const BRAND_THEME_BY_NAME = {
  [BRAND_GGT]: "GGT",
  [BRAND_GGV]: "GGV",
  [BRAND_GGD]: "GGD"
};

export { BRAND_GGD, BRAND_GGV, BRAND_GGT, BRAND_THEME_BY_NAME };
